export const HOW_TO_LEARN_PAGE_LIMIT = 20;
